<app-form-dialog-shell
  [icon]="isEditing ? 'edit' : 'add_circle'"
  [heading]="isEditing ? 'Editar módulo' : 'Nuevo módulo'"
  [saving]="saving()"
  [saveLabel]="isEditing ? 'Guardar cambios' : 'Crear módulo'"
  [saveIcon]="isEditing ? 'save' : 'add'"
  formId="module-form"
  (cancelled)="close()"
  >
<form [formGroup]="form" id="module-form" (ngSubmit)="onSubmit()">
    <div class="form-grid">

      <!-- Nombre -->
      <mat-form-field appearance="outline">
        <mat-label>Nombre interno</mat-label>
        <input matInput formControlName="name" placeholder="ej. USERS" />
        <mat-hint>Se guardará en mayúsculas</mat-hint>
        @if (fieldError('name')) {<mat-error>Nombre requerido (mín. 2 caracteres)</mat-error>}
      </mat-form-field>

      <!-- Etiqueta -->
      <mat-form-field appearance="outline">
        <mat-label>Etiqueta visible</mat-label>
        <input matInput formControlName="label" placeholder="ej. Usuarios" />
        <mat-hint>Es la que se ve en el menú y el título del módulo</mat-hint>
        @if (fieldError('label')) {<mat-error>Etiqueta requerida</mat-error>}
      </mat-form-field>

      <!-- Ruta -->
      <mat-form-field appearance="outline">
        <mat-label>Ruta</mat-label>
        <input matInput formControlName="route" placeholder="ej. /admin/users" />
        <mat-icon matPrefix>link</mat-icon>
        @if (fieldError('route')) {<mat-error>Ruta requerida</mat-error>}
      </mat-form-field>

      <!-- Ícono -->
      <mat-form-field appearance="outline" class="icon-field">
        <mat-label>Ícono</mat-label>
        <!-- Trigger explícito para evitar el bug "dashboarddashboard"
             (mat-icon usa ligaduras y Material concatena el texto). -->
        <mat-select
          formControlName="icon"
          (openedChange)="onIconSelectOpened($event)"
          >
          <mat-select-trigger>
            <div class="trigger-icon">
              <mat-icon>{{ form.get('icon')?.value || 'widgets' }}</mat-icon>
              <span>{{ form.get('icon')?.value || '—' }}</span>
            </div>
          </mat-select-trigger>

          <!-- Buscador dentro del dropdown -->
          <div class="select-search">
            <mat-icon>search</mat-icon>
            <input
              type="text"
              placeholder="Buscar ícono..."
              [value]="iconFilter()"
              (input)="onIconFilterChange($event)"
              (keydown)="$event.stopPropagation()"
              (click)="$event.stopPropagation()"
              />
          </div>

          @for (icon of filteredIcons(); track icon) {
            <mat-option [value]="icon">
              <div class="icon-option">
                <mat-icon>{{ icon }}</mat-icon>
                <span class="icon-name">{{ icon }}</span>
              </div>
            </mat-option>
            } @empty {
            <div class="no-icons">Sin coincidencias</div>
          }
        </mat-select>
      </mat-form-field>

      <!-- Descripción (ancho completo) -->
      <mat-form-field appearance="outline" class="full-col">
        <mat-label>Descripción</mat-label>
        <textarea matInput formControlName="description" rows="2"
        placeholder="Descripción opcional del módulo"></textarea>
      </mat-form-field>

      <!-- Activo -->
      <div class="toggle-row full-col">
        <mat-slide-toggle formControlName="active" color="primary">
          Módulo activo
        </mat-slide-toggle>
        <span class="toggle-hint">Los módulos inactivos no aparecen en el menú</span>
      </div>

    </div>
  </form>
</app-form-dialog-shell>
